import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'toll_service',
  label: {
    default: 'Toll Service',
    short: 'Toll Service',
  },
});
